// import { useCallback } from 'react'
// import { useNavigate } from 'react-router-dom'

import styles from './styles.module.scss'

export const Wrapper = ({ children }) => <div>{children}</div>

export const Content = () => {
  // const navigate = useNavigate()

  // const redirectToMain = useCallback(() => {
  //   navigate('/')
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  return (
    <div className={styles['page-not-found-block']}>
      <h1 className={styles.error}>404</h1>
      <h1>Page not found</h1>
      <p>Sorry, the page you are looking for could not be found</p>
      {/* <p>
        <Btn
          styles={['uppercase', 'fwidth_auto']}
          variant="filled"
          onClick={redirectToMain}
        >
          Go to the main page
        </Btn>
      </p> */}
    </div>
  )
}
